import IDownloadFile from "../models/IDownloadFile";

export const initialState: IDownloadFile = {
    fileList: {
        files: [],
        error: null,
        loading: false,
    },
    deleteFile: {
        success: false,
        error: null,
        loading: false
    },
    filePreparation: {
        success: false,
        error: null,
        loading: false
    },
    deleteSelectedFile: {
        success: false,
        error: null,
        loading: false
    }
};
